<template>
  <template v-if="pageList == 'maintain'">
    <!-- 週期性保養 -->
    <maintain></maintain>
  </template>
  <template v-else-if="pageList == 'maintainhistory'">
    <!-- 維修履歷 -->
    <maintainHistory></maintainHistory>
  </template>
  <template v-else-if="pageList == 'repairorder'">
    <!-- 報修單 -->
    <repairOrder></repairOrder>
  </template>
  <template v-else-if="pageList == 'sparemanagement'">
    <!-- 備品管理 -->
    <permissionSetting></permissionSetting>
  </template>
  <template v-else-if="pageList == 'devicesearch'">
    <!-- 設備資料查詢 -->
    <deviceSearch></deviceSearch>
  </template>
  <template v-else-if="pageList == 'devicecompany'">
    <!-- 設備商資訊 -->
    <deviceCompany></deviceCompany>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import permissionSetting from "@/components/permissionManagement/permissionSetting";
import maintain from "@/components/deviceManagement/maintain";
import repairOrder from "@/components/deviceManagement/repairOrder";
import maintainHistory from "@/components/deviceManagement/maintainHistory";
import deviceSearch from "@/components/deviceManagement/deviceSearch";
import deviceCompany from "@/components/deviceManagement/deviceCompany";
export default {
  components: {
    permissionSetting,
    maintain,
    repairOrder,
    maintainHistory,
    deviceSearch,
    deviceCompany,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();
    const pageListChild = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem(
        "mes-deviceManagement-pageList",
        pageList.value
      );
      sessionStorage.setItem(
        "mes-deviceManagement-pageListChild",
        pageListChild.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
      pageListChild.value = newValue.pageListChild;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;
      pageListChild.value = sideBarSelect.value.pageListChild;

      //session資料
      const mesDeviceManagementPageList = sessionStorage.getItem(
        "mes-deviceManagement-pageList"
      );
      const mesDeviceManagementPageListChild = sessionStorage.getItem(
        "mes-deviceManagement-pageListChild"
      );
      sessionStorage.removeItem("mes-deviceManagement-pageList");
      sessionStorage.removeItem("mes-deviceManagement-pageListChild");
      if (mesDeviceManagementPageList != null) {
        pageList.value = mesDeviceManagementPageList;
      }
      if (mesDeviceManagementPageListChild != null) {
        pageListChild.value = mesDeviceManagementPageListChild;
      }
    }, 0);

    provide("pageList", pageList);
    provide("pageListChild", pageListChild);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss"></style>
